"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var arraySupport_1 = __importDefault(require("dayjs/plugin/arraySupport"));
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
var isoWeek_1 = __importDefault(require("dayjs/plugin/isoWeek"));
var objectSupport_1 = __importDefault(require("dayjs/plugin/objectSupport"));
var quarterOfYear_1 = __importDefault(require("dayjs/plugin/quarterOfYear"));
var relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
var timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
var updateLocale_1 = __importDefault(require("dayjs/plugin/updateLocale"));
var advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
dayjs_1.default.extend(arraySupport_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
dayjs_1.default.extend(isoWeek_1.default);
dayjs_1.default.extend(quarterOfYear_1.default);
dayjs_1.default.extend(relativeTime_1.default);
dayjs_1.default.extend(timezone_1.default);
// advancedFormat requires timezone plugin
dayjs_1.default.extend(advancedFormat_1.default);
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(localizedFormat_1.default);
dayjs_1.default.extend(updateLocale_1.default);
// the modifications made in objectSupport would preserve other plugins behavior
// but not vice versa, therefore it should come last
dayjs_1.default.extend(objectSupport_1.default);
exports.default = dayjs_1.default;
